import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, PermissionGuard } from '@anadolu-commons/tohum-ui';
import { AnaSayfaComponent } from './ana-sayfa/ana-sayfa.component';
import { PageComponent } from './shared/page/page.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { YetkisizKullaniciComponent } from './yetkisiz-kullanici/yetkisiz-kullanici.component';


const routes: Routes = [
  {
    path: '',
    data: { redirectUrl: '' },
    component: WelcomeComponent
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module')
      .then(m => m.LoginModule)
  },
  {
    path: 'home',  component: PageComponent, data: { title: 'Anasayfa'}, canActivate: [AuthGuard], 
    children: [
      { path: '', data: { title: null }, component: AnaSayfaComponent },
      { 
        path: 'kullanici-yonetim', data: {title: 'Kullanıcı Yönetim', permissions:['KullaniciYonetimiGoruntuleme']}, canActivate: [AuthGuard, PermissionGuard], 
        loadChildren: () => import('./kullanici-yonetim/kullanici-yonetim.module').then(m => m.KullaniciYonetimModule)        
      },
      {        
        path: 'kurum-ic-degerlendirme', data: {title: 'İç Değerlendirme Raporları', permissions:['IcDegerlendirmeGoruntuleme']}, canActivate: [AuthGuard, PermissionGuard], 
        loadChildren: () => import('./kurum-ici-degerlendirme/kurum-ici-degerlendirme.module').then(m => m.KurumIciDegerlendirmeModule)
      }
    ]
  },
  {
    path: 'unauthorized',
    component: YetkisizKullaniciComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
